/**
 * Email verification gate disabled — email/password users may sign in without verifying.
 */
export function userNeedsEmailPasswordVerification(_user) {
  return false
}

export function getEmailVerificationContinueUrl() {
  if (typeof window === 'undefined') return 'https://primedocumentsign.web.app/'
  const { origin, pathname } = window.location
  return `${origin}${pathname || '/'}`
}
